__webpack_require__.p = "/type-memo-page/";